import { t } from '@hefe/i18n';
import { Gym } from '@hefe/models';
import { GymsSlice, ModalsSlice } from '@hefe/store';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';
import { Color } from 'antd/es/color-picker';

interface AddEditGymFormProps {
  gym?: Gym;
}

export default function AddEditGymForm(props: AddEditGymFormProps) {
  const { gym } = props;

  const dispatch = useAppDispatch();
  const modalState = useSelector(ModalsSlice.modalsState);

  const onSubmit = (values: any, resetForm: any) => {
    const closeModal = ModalsSlice.modalsActions.closeModal;
    const setModalLoading = ModalsSlice.modalsActions.setModalLoading;

    const action = gym ? GymsSlice.updateGym : GymsSlice.createGym;

    const color = (values?.color as Color)?.toHexString();

    dispatch(setModalLoading(true));
    dispatch(
      action({
        ...values,
        ...(gym ? { id: gym.id } : {}),
        color,
      })
    )
      .unwrap()
      .then(() => dispatch(closeModal()))
      .catch(() => null)
      .finally(() => dispatch(setModalLoading(false)));
  };

  return (
    <CustomForm
      key={`add-edit-gym-form-${gym ? gym.id : 'new'}`}
      formId={`add-edit-gym-form-${gym ? gym.id : 'new'}`}
      fields={[
        {
          name: 'name',
          label: t('name'),
          type: 'text',
          initalValue: gym?.name,
          rules: [
            {
              required: true,
              message: t('form_errors.name'),
            },
          ],
        },
        {
          name: 'street',
          label: t('street'),
          type: 'text',
          initalValue: gym?.street,
          rules: [],
        },
        {
          name: 'zipcode',
          label: t('zipcode'),
          type: 'number',
          initalValue: gym?.zipcode ? parseInt(gym?.zipcode) : undefined,
          rules: [
            {
              type: 'number',
              max: 99999,
              message: t('form_errors.number_max', { max: 99999 }),
            },
            {
              type: 'number',
              min: 1000,
              message: t('form_errors.number_min', { min: 1000 }),
            },
          ],
        },
        {
          name: 'city',
          label: t('city'),
          type: 'text',
          initalValue: gym?.city,
          rules: [],
        },
        {
          name: 'parking',
          label: t('parking'),
          type: 'text',
          initalValue: gym?.parking,
          rules: [],
        },
        {
          name: 'max_spectators',
          label: t('max_spectators'),
          type: 'number',
          initalValue: gym?.max_spectators,
          rules: [
            {
              type: 'number',
              message: t('form_errors.number'),
            },
            {
              type: 'number',
              min: 1,
              message: t('form_errors.number_min', { min: 1 }),
            },
          ],
        },
        {
          name: 'color',
          label: t('color'),
          type: 'colorpicker',
          initalValue: gym?.color,
          extraLabel: t('gyms.color.description'),
          rules: [],
        },
      ]}
      loading={modalState.modal.loading}
      onSubmit={onSubmit}
    />
  );
}
